<div *ngIf="isLoginError" class="red-text center error-message">
    <i class="material-icons">error</i> Incorrect username or password
</div>
<br/>
<mat-card>
  <mat-card-content>
    <h1 class="menu-sub-item-header mat-icon-container">SoftDiamond Administration Login</h1>
    <p>

      <form [formGroup]="loginForm" (ngSubmit)="OnSubmit(UserName.value,Password.value)">

        <div class="col">
          <div class="col1">
              <div class="mat-form-small-container">
                  <label>UserName:</label>
              </div>
          </div>
          <div class="col2">
              <div class="mat-form-small-container"  style="width: 100%;">
                <input type="text" #userName ngModel name="userName" placeholder="Username" formControlName="userName" required>
              </div>
          </div>
        </div>

        <div class="col">
          <div class="col1">
              <div class="mat-form-small-container">
                  <label>Password:</label>
              </div>
          </div>
          <div class="col2">
              <div class="mat-form-small-container"  style="width: 100%;">
                <input type="password" #password ngModel name="password" placeholder="Password" formControlName="password" required>
              </div>
          </div>
        </div>

        <div class="col">
          <div class="col1">
              <div class="mat-form-small-container">
                  &nbsp;
              </div>
          </div>
          <div class="col2">
              <div class="mat-form-small-container"  style="width: 100%;">
                <button [disabled]="!loginForm.valid" class="btn-large btn-submit" type="submit">Login</button>
              </div>
          </div>
        </div>

     </form>
  </mat-card-content>
</mat-card>
<br/>